import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';
import {
  PROPERTY_COLUMN_MATCH_SEGMENT,
  UOM_COLUMN_MATCH_SUFFIX,
  parseDisplayNameColumnName,
} from '@/tableDefinitionEditor/columnMatch.constants';
import type { MaterializedTableHeader, ProcessedTableCell } from '@/tableDefinitionEditor/tableDefinition.types';

export const getHeaderName = (header: MaterializedTableHeader) => header.name ?? '';

/* Filter out property columns and uom columns from headers and rows so we do not put extra data in the store */
export const filterPropertyAndUomColumns = (
  headers: MaterializedTableHeader[],
  processedRows: ProcessedTableCell[][],
  hasMore: boolean,
) => {
  const propertyAndUomColumnIndices = headers
    .map((header, index) => ({ name: getHeaderName(header), index }))
    .filter(
      ({ name }) =>
        name.includes(PROPERTY_COLUMN_MATCH_SEGMENT) ||
        parseDisplayNameColumnName(name) !== null ||
        name.includes(UOM_COLUMN_MATCH_SUFFIX) ||
        name.includes(SeeqNames.MaterializedTables.MaterializedTableJoinSuffix),
    )
    .map(({ index }) => index);
  const filteredHeaders = headers.filter((_, index) => !propertyAndUomColumnIndices.includes(index));
  const filteredRows = processedRows.map((row) =>
    row.filter((_, index) => !propertyAndUomColumnIndices.includes(index)),
  );

  return {
    headers: filteredHeaders,
    rows: filteredRows,
    hasMore,
  };
};
